import { render, staticRenderFns } from "./BlockUnblockSomeRequestTypes.vue?vue&type=template&id=67812724&scoped=true&"
import script from "./BlockUnblockSomeRequestTypes.vue?vue&type=script&lang=js&"
export * from "./BlockUnblockSomeRequestTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67812724",
  null
  
)

export default component.exports